<ms-option-panel
    [optionGroup]="activeOptionGroup() || sourceOptionGroup"
    [event]="activeEvent() || sourceEvent"
    [showMarketHelp]="showMarketHelp"
    [promoted]="promoted"
    [tracking]="tracking"
    [trackingModuleType]="trackingModuleType"
    [crmPromoted]="crmPromoted"
    [crmPromoIdsMap]="crmPromoIdsMap"
    [showMoreCounter]="showMoreCounter"
    [optionsLimitOverride]="optionsLimitOverride"
    [showHelp]="true"
    [thresholds]="thresholds"
    [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
    [sourceOfPick]="sourceOfPick"
    [showEventName]="showEventName"
    [showEventTimer]="showEventTimer"
    [toggleable]="toggleable"
    [isLinkToEvent]="isLinkToEvent"
    [showEventChevron]="showEventChevron"
    [babButtonSource]="babButtonSource"
    [hideMarketHeader]="hideMarketHeader"
    [showSixPackLogosColor]="showSixPackLogosColor"
    [showSixPackLogos]="showSixPackLogos"
    [selectedSetId]="selectedSetId"
    [isInSheetView]="isInSheetView"
    [hideOptions]="hideOptions()"
    (closeBtnClicked)="closeBtnClicked()"
    (activePeriodChange)="onActivePeriodChange($event)">
    @if (isCarouselApplicable()) {
        <ms-sheet-view-carousel
            [sourceEvent]="sourceEvent"
            [sourceOptionGroup]="sourceOptionGroup"
            [dynamicOfferCategory]="dynamicOfferCategory"
            (eventChange)="eventChange($event)"
            (periodChange)="periodChange($event)" />
    }

    @if (hideOptions()) {
        <ms-epcot-notification
            [message]="sitecore.event.ErrMarketUnavailableMessage"
            [notificationHeaderTitle]="sitecore.event.ErrMarketUnavailableTitle"
            [notificationType]="'info'" />
    }
</ms-option-panel>
